import React, { useContext, useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { useHistory } from "react-router";
import { Dialog, DialogTitle, DialogContent, Grid } from "@material-ui/core";
// Different sections of stepper
import ContactAreaSection from "../Create/ContactArea";
import WorkInformationSection from "../Create/WorkInformation";
import CoachingCapacitySection from "../Create/CoachingCapacity";
import TrainingAndDevelopmentSection from "../Create/TrainingAndDevelopment";
import MentoringCapacitySection from "../Create/MentoringCapacity";
import CoachingProfileSection from "../Create/CoachingProfile";
import MentorProfileSection from "../Create/MentorProfile";
import FacilitationSection from "../Create/Facilitation";
import AccessmentSection from "../Create/Accessment";
import GdprSection from "../Create/Gdpr";
import BackgroundSection from "../Create/Background";
import CoachingBackgroundSection from "../Create/CoachingBackground";
import { ValidateEmail } from "../../../../../Common/Utils/common_utils";
// Different actions to perform
import {
  SetContactAreaOrgId,
  UpdateContactArea,
  SetContactArea,
  SetContactAreaError,
} from "../Create/ContactArea/ContactAreaActions";
import {
  UpdateEmployeeIdWorkInformation,
  UpdateWorkInformation,
  SetWorkInformationError,
  SetWorkInformation,
} from "../Create/WorkInformation/WorkInformationActions";
import {
  UpdateEmployeeIdTrainingAndDevelopment,
  UpdateTrainingAndDevelopment,
  SetTrainingAndDevelopmentError,
  SetTrainingAndDevelopment,
} from "../Create/TrainingAndDevelopment/TrainingAndDevelopmentActions";
import {
  UpdateEmployeeIdCoachingCapacity,
  UpdateCoachingCapacity,
  SetCoachingCapacityError,
  SetCoachingCapacity,
} from "../Create/CoachingCapacity/CoachingCapatityActions";
import {
  UpdateEmployeeIdMentoringCapacity,
  UpdateMentoringCapacity,
  SetMentoringCapacityError,
  SetMentoringCapacity,
} from "../Create/MentoringCapacity/MentoringCapatityActions";
import {
  UpdateEmployeeIdCoachingProfile,
  UpdateCoachingProfile,
  SetCoachingProfileError,
  SetCoachingProfile,
} from "../Create/CoachingProfile/CoachingProfileActions";
import {
  UpdateEmployeeIdMentorProfile,
  UpdateMentorProfile,
  SetMentorProfileError,
  SetMentorProfile,
} from "../Create/MentorProfile/MentorProfileActions";
import {
  UpdateEmployeeIdFacilitation,
  UpdateFacilitation,
  SetFacilitationError,
  SetFacilitation,
} from "../Create/Facilitation/FacilitationActions";
import {
  UpdateEmployeeIdAccessment,
  UpdateAccessment,
  SetAccessmentError,
  SetAccessment,
} from "../Create/Accessment/AccessmentActions";
import {
  UpdateEmployeeIdGdpr,
  UpdateGdpr,
  SetGdprError,
  SetGdpr,
} from "../Create/Gdpr/GdprActions";
import {
  UpdateEmployeeIdBackground,
  UpdateBackground,
  SetBackgroundError,
  SetBackground,
} from "../Create/Background/BackgroundActions";
import {
  UpdateEmployeeIdCoachingBackground,
  UpdateCoachingBackground,
  SetCoachingBackgroundError,
  SetCoachingBackground,
} from "../Create/CoachingBackground/CoachingBackgroundActions";
import { useSelector, useDispatch } from "react-redux";
import DataService from "../../../../../Service";
import Loader from "../../../../../Components/Loader";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useParams, useLocation } from "react-router-dom";
import {
  SET_EMPLOYEE_DROPDOWN_VALUES,
  SET_EMPLOYEE_UPLOAD_FILES,
} from "../../../../../Redux/actions";
import { UploadFilesComponentContext } from "../../../../../Components/FormGenerator/context/UploadFilesComponentContext";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(1),
    textTransform: "none",
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperButtons: {
    position: "sticky",
    display: "flex",
    justifyContent: "space-between",
    bottom: "0px",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
  stepperContent: {
    position: "sticky",
    top: "217px",
    backgroundColor: "white",
    zIndex: 2,
    paddingBottom: "20px",
  },
  stepperContentCreate: {
    // top: "215px",
    top: "195px",
    position: "sticky",
    backgroundColor: "white",
    zIndex: 2,
    paddingBottom: "20px",
  },
  stepperLabel: {
    ["@media (max-width:1700px)"]: {
      width: "100%",
      fontSize: "0.76rem",
      height: "100%",
      maxWidth: "4.8rem",
      wordWrap: "break-word",
    },
  },
}));

// const theme = createMuiTheme({
//   overrides: {
//     MuiStepper: {
//       root: {
//         padding: "0px",
//       },
//     },
//     MuiStep: {
//       root: {
//         width: "200px",
//         border: "1px solid rgb(7, 127,131)",
//         padding: "10px",
//         margin: "2px",
//       },
//       completed: {
//         backgroundColor: "rgb(7, 127,131)",
//       },
//       active: {
//         backgroundColor: "rgb(7, 127,131)",
//       },
//     },
//     MuiStepLabel: {
//       label: {
//         color: "rgb(7, 127,131)",
//         fontWeight: "normal",
//         fontSize: "10px",
//       },
//       active: {
//         color: "white !important",
//       },
//       completed: {
//         color: "white !important",
//       },
//     },
//     MuiStepIcon: {
//       root: {
//         color: "rgb(7, 127,131)",
//       },
//       completed: {
//         color: "white !important",
//       },
//       active: {
//         color: "white !important",
//       },
//       text: {
//         fill: "black",
//       },
//     },
//     MuiButton: {
//       containedPrimary: {
//         backgroundColor: "rgb(7, 127,131)",
//       },
//       containedSecondary: {
//         backgroundColor: "#EF7000",

//         '&:hover': {
//           backgroundColor: "#EF7000"
//         }

//       },
//     },
//   },
// });

export default function EmployeeLinearStepper(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [employeeImageBlob, setEmployeeImageBlob] = useState(null);
  const [employeeImageBlob1, setEmployeeImageBlob1] = useState(null);
  const [employeeImageBlob2, setEmployeeImageBlob2] = useState(null);
  const [activeStep, setActiveStep] = React.useState(0);
  let location = useLocation();
  const history = useHistory();
  let { id, employeeid } = useParams();
    const globaluserData = useSelector((state) => state.commonReducer);
    const userRole = globaluserData?.role;
  const [feildIsMandatory, setFeildIsMandatory] = useState(true);
  const [tabIndex, setTabIndex] = useState(false);
  const [empID, setEmpID] = useState("");
  const [jobRoleData, setJobRole] = useState([]);
  const [filterJobLength, setFilterJobLength] = useState("");
  const [filterJobLength1, setFilterJobLength1] = useState("");
  const [filterJobLength2, setFilterJobLength2] = useState("");
  const [filterJobLength3, setFilterJobLength3] = useState("");
  useEffect(() => {
    if (userRole === "employee") {
      setFeildIsMandatory(false);
    }
  }, []);
  const global_data_common = useSelector((state) => state.commonReducer);
  const jobRole = global_data_common.jobRole;
  const { fileDataState, fetchedFilesState } = useContext(
    UploadFilesComponentContext
  );
  const [movable, setMovable] = useState(false);
  //
  const [someChangeDetected, setSomeChangeDetected] = useState(false);

  const jobRoleVal = localStorage.getItem("JobRole");

  // selected file data
  const { fileData } = fileDataState;

  //fetched files from the server
  const { setFetchedFiles, fetchedFiles } = fetchedFilesState;
  fetchedFiles?.length && fetchedFiles.reverse();
  //---------------------------------------------------------------------
  //-------------------- Contact Area files  --------------------
  let contactAreaPictureFile = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "contact_area_picture") {
      contactAreaPictureFile.file_type = item.type;
      contactAreaPictureFile.file = item.files;
    }
  });

  //---------------------------------------------------------------------
  //-------------------- Coaching profile capacity files  --------------------
  let coachingProfileCapacityFile = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "coaching_profile_picture") {
      coachingProfileCapacityFile.file_type = item.type;
      coachingProfileCapacityFile.file = item.files;
    }
  });

  //---------------------------------------------------------------------
  //-------------------- Mentor profile  files  --------------------
  // MentorProfileFormData
  let mentorProfileFile = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "mentor_profile_picture") {
      mentorProfileFile.file_type = item.type;
      mentorProfileFile.file = item.files;
    }
  });

  useEffect(() => {
    if (employeeid) {
      // fetching files
      DataService.getDirectData(
        `/employees/listing_files?employee_id=${employeeid}`
      )
        .then((res) => {
          setFetchedFiles(res.employee_images);
          dispatch({
            type: SET_EMPLOYEE_UPLOAD_FILES,
            payload: res.employee_images,
          });
        })
        .catch((err) => console.log("error"));
    }
  }, [activeStep]);
  useEffect(() => {
    setLoading(true);
    if (id) {
      // fetching files
      DataService.getDirectData(`/employees/listing_files?employee_id=${empID}`)
        .then((res) => {
          setFetchedFiles(res.employee_images);
          dispatch({
            type: SET_EMPLOYEE_UPLOAD_FILES,
            payload: res.employee_images,
          });
        })
        .catch((err) => console.log("error"));

      DataService.getData({ organisation_id: id }, "all_employee_dropdowns")
        .then((response) => {
          dispatch({ type: SET_EMPLOYEE_DROPDOWN_VALUES, payload: response });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          dispatch(showSnackbar("error", err.errors));
        });
    } else {
      DataService.getData({}, "all_employee_dropdowns")
        .then((response) => {
          dispatch({ type: SET_EMPLOYEE_DROPDOWN_VALUES, payload: response });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          dispatch(showSnackbar("error", err.errors));
        });
    }

    dispatch(SetContactAreaOrgId(id));
    if (employeeid) {
      setLoading(true);
      DataService.getDirectData(`/employees/${employeeid}`)
        .then((res) => {
          setMovable(res.movable);
          const jobRoleList = res.emp_job_role_lists;
          sessionStorage.setItem("jobRoleList", jobRoleList);
          // setJobRole(res.emp_job_role_lists)
          const filterJob =
            jobRoleList?.length > 0 &&
            jobRoleList.filter((row) => row === "Internal Coach");
          const filterJob1 =
            jobRoleList?.length > 0 &&
            jobRoleList.filter((row) => row === "Internal Mentor");
          const filterJob2 =
            jobRoleList?.length > 0 &&
            jobRoleList.filter((row) => row === "Internal Facilitator");
          const filterJob3 =
            jobRoleList?.length > 0 &&
            jobRoleList.filter((row) => row === "Internal Assessor");
          const filterJobLength = filterJob.toString();
          const filterJobLength1 = filterJob1.toString();
          const filterJobLength2 = filterJob2.toString();
          const filterJobLength3 = filterJob3.toString();
          setFilterJobLength2(filterJobLength2);
          setFilterJobLength3(filterJobLength3);
          setFilterJobLength(filterJobLength);
          setFilterJobLength1(filterJobLength1);

          dispatch(UpdateContactArea(res.data));
          dispatch(
            UpdateEmployeeIdWorkInformation({
              section_id: res.employee_work_info_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdTrainingAndDevelopment({
              section_id: res.employee_training_development_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdCoachingCapacity({
              section_id: res.employee_coaching_capacity_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdMentoringCapacity({
              section_id: res.employee_mentoring_capacity_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdCoachingProfile({
              section_id: res.employee_coaching_profile_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdMentorProfile({
              section_id: res.employee_mentoring_profile_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdFacilitation({
              section_id: res.employee_facilitation_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdAccessment({
              section_id: res.employee_assessment_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdGdpr({
              section_id: res.employee_gdpr_id,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdBackground({
              section_id: res.employee_background,
              id: employeeid,
            })
          );
          dispatch(
            UpdateEmployeeIdCoachingBackground({
              section_id: res.employee_coaching_background,
              id: employeeid,
            })
          );
          res &&
            res.employee_work_info_id &&
            DataService.getDirectData(
              `/employee_work_infos/${res.employee_work_info_id}`
            )
              .then((response) => {
                // for solving error issue in workinfo
                const selected_job_roles = response.data?.job_role_lists.map(
                  (item) => item.job_role
                );

                // setJobRole(response.emp_job_role_lists)

                dispatch(
                  SetWorkInformation({ ...response.data, selected_job_roles })
                );
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_training_development_id &&
            DataService.getDirectData(
              `/employee_training_developments/${res.employee_training_development_id}`
            )
              .then((response) => {
                dispatch(SetTrainingAndDevelopment(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_coaching_capacity_id &&
            DataService.getDirectData(
              `/employee_coaching_mentoring_capacities/${res.employee_coaching_capacity_id}`
            )
              .then((response) => {
                dispatch(SetCoachingCapacity(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_mentoring_capacity_id &&
            DataService.getDirectData(
              `/employee_coaching_mentoring_capacities/${res.employee_mentoring_capacity_id}`
            )
              .then((response) => {
                dispatch(SetMentoringCapacity(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_coaching_profile_id &&
            DataService.getDirectData(
              `/employee_coaching_mentoring_profiles/${res.employee_coaching_profile_id}`
            )
              .then((response) => {
                dispatch(SetCoachingProfile(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_mentoring_profile_id &&
            DataService.getDirectData(
              `/employee_coaching_mentoring_profiles/${res.employee_mentoring_profile_id}`
            )
              .then((response) => {
                dispatch(SetMentorProfile(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_facilitation_id &&
            DataService.getDirectData(
              `/employee_facilitations/${res.employee_facilitation_id}`
            )
              .then((response) => {
                dispatch(SetFacilitation(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_assessment_id &&
            DataService.getDirectData(
              `/employee_assessments/${res.employee_assessment_id}`
            )
              .then((response) => {
                dispatch(SetAccessment(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          res &&
            res.employee_gdpr_id &&
            DataService.getDirectData(`/employee_gdprs/${res.employee_gdpr_id}`)
              .then((response) => {
                dispatch(SetGdpr(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });
          res &&
            res.employee_background &&
            DataService.getDirectData(
              `/employee_backgrounds/${res.employee_background}`
            )
              .then((response) => {
                dispatch(SetBackground(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });
          res &&
            res.employee_coaching_background &&
            DataService.getDirectData(
              `/employee_coaching_backgrounds/${res.employee_coaching_background}`
            )
              .then((response) => {
                dispatch(SetCoachingBackground(response.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [activeStep]);

  function getSteps() {
    return [
      "Contact area",
      "Work info and history",
      "Training and development",
      "Coaching capacity",
      "Mentoring capacity",
      "Background",
      "Coaching background",
      "Coaching profile",
      "Mentor profile",
      "Facilitation profile",
      "Assessment profile",
      "GDPR",
    ];
  }

  const employeeId = useSelector((state) => state.contactAreaReducer.data.id);
  const ContactArea = useSelector((state) => state.contactAreaReducer);
  const WorkInformation = useSelector((state) => state.workInformationReducer);
  const CoachingCapacity = useSelector(
    (state) => state.coachingCapacityReducer
  );
  const TrainingAndDevelopment = useSelector(
    (state) => state.trainingAndDevelopmentReducer
  );
  const MentoringCapacity = useSelector(
    (state) => state.mentoringCapacityReducer
  );
  const CoachingProfileCapacity = useSelector(
    (state) => state.coachingProfileReducer
  );
  const MentorProfile = useSelector((state) => state.mentorProfileReducer);
  const Facilitation = useSelector((state) => state.facilitationReducer);
  const Accessment = useSelector((state) => state.accessmentReducer);
  const Gdpr = useSelector((state) => state.gdprReducer);
  const Background = useSelector((state) => state.backgroundReducer);
  const CoachingBackground = useSelector(
    (state) => state.coachingBackgroundReducer
  );
  const coaching_profile_picture = useSelector(
    (state) => state.commonReducer.employeeUploads
  );
  let authHeaders = JSON.parse(sessionStorage.getItem("authorization_headers"));

  // for section first
  //----------------------------------------------------------------------
  //-------------------- contact Area form data --------------------
  const ContactAreaFormData = new FormData();

  for (const key in ContactArea.data) {
    const data = ContactArea.data;

    // if key of the object is an Array
    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        ContactAreaFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          ContactAreaFormData.append(`${key}[]`, option);
        });
      }
    } else {
      ContactAreaFormData.append(key, data[key]);
    }
  }

  ContactAreaFormData.delete("organisation_id");
  ContactAreaFormData.append("organisation_id", id);

  if (employeeImageBlob) {
    ContactAreaFormData.append("contact_area_picture[]", employeeImageBlob);
  }

  const WorkInformationFormData = new FormData();

  for (const key in WorkInformation.data) {
    const data = WorkInformation.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        WorkInformationFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          WorkInformationFormData.append(`${key}[]`, option);
        });
      }
    } else {
      WorkInformationFormData.append(key, data[key]);
    }
  }
  WorkInformationFormData.delete("selected_job_roles[]");

  const TrainingAndDevelopmentFormData = new FormData();

  for (const key in TrainingAndDevelopment.data) {
    const data = TrainingAndDevelopment.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        TrainingAndDevelopmentFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          TrainingAndDevelopmentFormData.append(`${key}[]`, option);
        });
      }
    } else {
      TrainingAndDevelopmentFormData.append(key, data[key]);
    }
  }

  const CoachingCapacityFormData = new FormData();

  for (const key in CoachingCapacity.data) {
    const data = CoachingCapacity.data;

    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        CoachingCapacityFormData.append(`${key}[]`, item);
      });
    } else {
      CoachingCapacityFormData.append(key, data[key]);
    }
  }

  const MentoringCapacityFormData = new FormData();

  for (const key in MentoringCapacity.data) {
    const data = MentoringCapacity.data;

    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        MentoringCapacityFormData.append(`${key}[]`, item);
      });
    } else {
      MentoringCapacityFormData.append(key, data[key]);
    }
  }

  const CoachingProfileCapacityFormData = new FormData();

  for (const key in CoachingProfileCapacity.data) {
    const data = CoachingProfileCapacity.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        CoachingProfileCapacityFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          CoachingProfileCapacityFormData.append(`${key}[]`, option);
        });
      }
    } else {
      CoachingProfileCapacityFormData.append(key, data[key]);
    }
  }

  if (employeeImageBlob1) {
    CoachingProfileCapacityFormData.append("picture[]", employeeImageBlob1);
  }

  const MentorProfileFormData = new FormData();

  for (const key in MentorProfile.data) {
    const data = MentorProfile.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        MentorProfileFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          MentorProfileFormData.append(`${key}[]`, option);
        });
      }
    } else {
      if (data[key] !== " ") {
        MentorProfileFormData.append(key, data[key]);
        console.log(key, data[key], "found non empty field running");
      } else {
        console.log("found empty field running");
      }
    }
  }
  if (employeeImageBlob2) {
    MentorProfileFormData.append("picture[]", employeeImageBlob2);
  }

  const FacilitationFormData = new FormData();

  for (const key in Facilitation.data) {
    const data = Facilitation.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        FacilitationFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          FacilitationFormData.append(`${key}[]`, option);
        });
      }
    } else {
      FacilitationFormData.append(key, data[key]);
    }
  }

  const AccessmentFormData = new FormData();
  for (const key in Accessment.data) {
    const data = Accessment.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        AccessmentFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          AccessmentFormData.append(`${key}[]`, option);
        });
      }
    } else {
      AccessmentFormData.append(key, data[key]);
    }
  }

  const GdprFormData = new FormData();
  for (const key in Gdpr.data) {
    const data = Gdpr.data;
    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        GdprFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          GdprFormData.append(`${key}[]`, option);
        });
      }
    } else {
      GdprFormData.append(key, data[key]);
    }
  }

  const BackgroundFormData = new FormData();
  for (const key in Background.data) {
    const data = Background.data;
    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        BackgroundFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          BackgroundFormData.append(`${key}[]`, option);
        });
      }
    } else {
      BackgroundFormData.append(key, data[key]);
    }
  }

  const CoachingBackgroundFormData = new FormData();
  for (const key in CoachingBackground.data) {
    const data = CoachingBackground.data;
    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        CoachingBackgroundFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          CoachingBackgroundFormData.append(`${key}[]`, option);
        });
      }
    } else {
      CoachingBackgroundFormData.append(key, data[key]);
    }
  }

  const lastValue = useCallback(
    (key) => {
      const uploadItem = [...fetchedFiles];
      uploadItem?.reverse();
      return {
        url: uploadItem?.find((item) => item.type === key)?.url,
        id: uploadItem?.find((item) => item.type === key)?.id,
      };
    },
    [fetchedFiles]
  );

  function getStepContent(step) {
    const profilePicture =
      fetchedFiles?.length &&
      fetchedFiles.find((item) => item.type === "contact_area_picture");
    const profilePicture1 =
      fetchedFiles?.length &&
      fetchedFiles.find((item) => item.type === "coaching_profile_picture");
    const profilePicture2 =
      fetchedFiles?.length &&
      fetchedFiles.find((item) => item.type === "mentor_profile_picture");

    switch (step) {
      case 0:
        return employeeid ? (
          <ContactAreaSection
            setSomeChangeDetected={setSomeChangeDetected}
            setImageBlob={setEmployeeImageBlob}
            existingImage={profilePicture}
          />
        ) : (
          <ContactAreaSection
            setSomeChangeDetected={setSomeChangeDetected}
            setImageBlob={setEmployeeImageBlob}
            existingImage={profilePicture}
          />
        );

      // OrganisationDetail.data?.id && (
      case 1:
        return (
          <WorkInformationSection
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 2:
        return (
          <TrainingAndDevelopmentSection
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 3:
        return (
          <CoachingCapacitySection
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 4:
        return (
          <MentoringCapacitySection
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 5:
        return (
          <BackgroundSection setSomeChangeDetected={setSomeChangeDetected} />
        );
      case 6:
        return (
          <CoachingBackgroundSection
            tabIndex
            activeStep
            filterJobLength
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 7:
        return (
          <CoachingProfileSection
            setSomeChangeDetected={setSomeChangeDetected}
            setImageBlob={setEmployeeImageBlob1}
            // existingImage={lastValue("coaching_profile_picture")}
            existingImage={profilePicture1}
          />
        );
      case 8:
        return (
          <MentorProfileSection
            setSomeChangeDetected={setSomeChangeDetected}
            setImageBlob={setEmployeeImageBlob2}
            // existingImage={lastValue("mentor_profile_picture")}
            existingImage={profilePicture2}
          />
        );
      case 9:
        return (
          <FacilitationSection setSomeChangeDetected={setSomeChangeDetected} />
        );
      case 10:
        return (
          <AccessmentSection setSomeChangeDetected={setSomeChangeDetected} />
        );
      case 11:
        if (userRole === "admin") {
          return <GdprSection setSomeChangeDetected={setSomeChangeDetected} />;
        } else {
          return;
        }

      default:
        return "Not available";
    }
  }

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [indexValue, setIndexValue] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps()
    ?.map((el) => {
      if (userRole === "admin") {
        return el;
      } else {
        if (el === "GDPR") {
          return;
        } else {
          return el;
        }
      }
    })
    .filter((el) => el !== undefined);

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (
    data,
    apiVariable,
    dispatchVariable,
    sectionId,
    onlySave,
    proceedFurther
  ) => {
   

    if (sectionId !== null) {
      setLoading(true);
      DataService.updateData(data, sectionId, apiVariable)
        .then((res) => {
          dispatch(dispatchVariable(res.data));
          setLoading(false);
          window.scroll({ top: 0 });
          if (apiVariable === "employee_contact_area") {
            setMovable(res.movable);
            setJobRole(res.emp_job_role_lists);
            sessionStorage.setItem("jobRoleList", res.emp_job_role_lists);
          }
          if (apiVariable === "employee_work_information") {
            const jobRoleList = res.data.emp_job_role_lists;
            sessionStorage.setItem("jobRoleList", jobRoleList);
            const filterJob =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Coach");
            const filterJob1 =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Mentor");
            const filterJob2 =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Facilitator");
            const filterJob3 =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Assessor");
            const filterJobLength1 = filterJob1.toString();
            const filterJobLength2 = filterJob2.toString();
            const filterJobLength3 = filterJob3.toString();
            setFilterJobLength2(filterJobLength2);
            setFilterJobLength3(filterJobLength3);
            const filterJobLength = filterJob.toString();
            setFilterJobLength(filterJobLength);
            setFilterJobLength1(filterJobLength1);
          }
          dispatch(showSnackbar("success", ["Success!"]));
          if (!onlySave) {
            proceedFurther
              ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
              : setActiveStep(indexValue);
          } else {
            setSomeChangeDetected(false);
          }
        })
        .catch((err) => {
          dispatch(showSnackbar("error", err.errors));
        });
    } else {
      setLoading(true);
      DataService.createData(data, apiVariable)
        .then((res) => {
          setLoading(false);
          window.scroll({ top: 0 });
          if (apiVariable === "employee_contact_area") {
            setMovable(res.movable);
            setEmpID(res.data.id);
            setJobRole(res.job_role_lists);
            sessionStorage.setItem("jobRoleList", res.emp_job_role_lists);
          }
          if (apiVariable === "employee_work_information") {
            const jobRoleList = res.data.emp_job_role_lists;
            sessionStorage.setItem("jobRoleList", jobRoleList);
            const filterJob =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Coach");
            const filterJob1 =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Mentor");
            const filterJob2 =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Facilitator");
            const filterJob3 =
              jobRoleList?.length > 0 &&
              jobRoleList.filter((row) => row === "Internal Assessor");
            const filterJobLength1 = filterJob1.toString();
            const filterJobLength2 = filterJob2.toString();
            const filterJobLength3 = filterJob3.toString();
            setFilterJobLength2(filterJobLength2);
            setFilterJobLength3(filterJobLength3);
            const filterJobLength = filterJob.toString();
            setFilterJobLength(filterJobLength);
            setFilterJobLength1(filterJobLength1);
          }
          dispatch(showSnackbar("success", ["Success!"]));
          if (dispatchVariable === UpdateContactArea) {
            dispatch(dispatchVariable(res.data));
            dispatch(
              UpdateEmployeeIdWorkInformation({
                section_id: res.employee_work_info_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdTrainingAndDevelopment({
                section_id: res.employee_training_development_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdCoachingCapacity({
                section_id: res.employee_coaching_capacity_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdMentoringCapacity({
                section_id: res.employee_mentoring_capacity_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdCoachingProfile({
                section_id: res.employee_coaching_profile_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdMentorProfile({
                section_id: res.employee_mentoring_profile_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdFacilitation({
                section_id: res.employee_facilitation_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdAccessment({
                section_id: res.employee_assessment_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdGdpr({
                section_id: res.employee_gdpr_id,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdBackground({
                section_id: res.employee_background,
                id: res.data.id,
              })
            );
            dispatch(
              UpdateEmployeeIdCoachingBackground({
                section_id: res.employee_coaching_background,
                id: res.data.id,
              })
            );
          } else {
            dispatch(dispatchVariable(res.data));
          }
          if (!onlySave) {
            proceedFurther
              ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
              : setActiveStep(indexValue);
          } else {
            setSomeChangeDetected(false);

            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          dispatch(showSnackbar("error", err.errors));
        });
    }
    setOpen(false);
  };
    const userRoleInternal = globaluserData?.jobRole;
  // ((index === 6 ||
  //   index === 3 ||
  //   index === 7) &&
  //   filterJobLength !== "Internal Coach") ||
  // ((index === 4 || index === 8) && filterJobLength1 !== "Internal Mentor")
  // || (userRoleInternal && userRoleInternal.includes("Internal") === false && index ===2 ) ||
  // (index === 9 &&
  //   filterJobLength2 !== "Internal Facilitator") ||
  // (index === 10 && filterJobLength3 !== "Internal Assessor")
  if (
    //   ((activeStep === 5 ||
    //   activeStep === 2 ||
    //   activeStep === 6) &&
    //   filterJobLength !== "Internal Coach") ||
    // ((activeStep === 3 || activeStep === 7) && filterJobLength1 !== "Internal Mentor")
    // || (userRoleInternal && userRoleInternal.includes("Internal") === false && activeStep ===2 ) ||
    // (activeStep === 8 &&
    //   filterJobLength2 !== "Internal Facilitator") ||
    // (activeStep === 9 && filterJobLength3 !== "Internal Assessor")
    // activeStep === 5  || activeStep === 4  ||
    ((activeStep === 6 || activeStep === 3 || activeStep === 7) &&
      filterJobLength !== "Internal Coach") ||
    ((activeStep === 8 || activeStep === 4) &&
      filterJobLength1 !== "Internal Mentor") ||
    (activeStep === 9 && filterJobLength2 !== "Internal Facilitator") ||
    (activeStep === 10 && filterJobLength3 !== "Internal Assessor") ||
    (activeStep === 2 &&
      userRoleInternal &&
      userRoleInternal.includes("Internal") === false)
  ) {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  const handleNext = (e) => {
    let onlySave = e?.target?.innerText.toLowerCase() === "Save".toLowerCase();
    let proceedFurther =
      e?.target?.innerText.toLowerCase() === "Save and proceed".toLowerCase();

    if (activeStep === 0) {
      let valid = true;
      let errors = {
        title_id: false,
        first_name: false,
        middle_name: false,
        last_name: false,
        primary_email: false,
        authorisation_to_access_the_service: false,
        authorisation_provided_by: false,
        nationality_list_id: false,
        bame: false,
        diversity_and_inclusion: false,
        mobile: false,
        phone: false,
        access_level: false,
        languages_list: false,
      };
      if (
        !(ContactArea.data?.languages_list?.length > 0) &&
        !feildIsMandatory
      ) {
        errors.languages_list = true;
        valid = false;
      }
      if (!ContactArea.data.first_name || !ContactArea.data.first_name.length) {
        errors.first_name = true;
        valid = false;
      }
      // if (
      //   (!ContactArea.data.middle_name ||
      //     !ContactArea.data.middle_name.length) &&
      //   !feildIsMandatory
      // ) {
      //   errors.middle_name = true;
      //   valid = false;
      // }
      if (!ContactArea.data.last_name || !ContactArea.data.last_name.length) {
        errors.last_name = true;
        valid = false;
      }
      if (ValidateEmail(ContactArea.data.primary_email)) {
        errors.primary_email = true;
        valid = false;
      }
      if (!valid) {
        dispatch(SetContactAreaError(errors));
        return;
      }
      if (valid) {
        handleSubmit(
          ContactAreaFormData,
          "employee_contact_area",
          UpdateContactArea,
          ContactArea.section_id,
          onlySave,
          proceedFurther
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 1) {
      let valid = true;
      let errors = {
        group: false,
        job_title: false,
        employee_status_id: false,
        current_role_history_notes: false,
        date_follow_up_contact_made: false,
        organisation_moved_to: false,
        level: false,
        line_manager_name: false,
        line_manager_contact_details: false,
        hr_sponsor_title: false,
        hr_sponsor_contact_details: false,
        city: false,
        county: false,
        country_list_id: false,
        zipcode: false,
        postcode: false,
        mobile: false,
        phone: false,
        selected_job_roles: false,
        left_organisation_follow_up_action: false,
        access_level: false,
        address: false,
        magic20_fields: {},
      };
      if (
        !WorkInformation.data.job_title &&
        !(WorkInformation.data.job_title?.length > 0) &&
        userRole === "employee"
      ) {
        errors.job_title = true;
        valid = false;
      }

      if (
        (!WorkInformation.data.line_manager_name ||
          !WorkInformation.data.line_manager_name.length) &&
        userRole === "employee"
      ) {
        errors.line_manager_name = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.line_manager_contact_details ||
          !WorkInformation.data.line_manager_contact_details.length) &&
        userRole === "employee"
      ) {
        errors.line_manager_contact_details = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.hr_sponsor_title ||
          !WorkInformation.data.hr_sponsor_title.length) &&
        userRole === "employee"
      ) {
        errors.hr_sponsor_title = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.hr_sponsor_name ||
          !WorkInformation.data.hr_sponsor_name.length) &&
        userRole === "employee"
      ) {
        errors.hr_sponsor_name = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.hr_sponsor_contact_details ||
          !WorkInformation.data.hr_sponsor_contact_details.length) &&
        userRole === "employee"
      ) {
        errors.hr_sponsor_contact_details = true;
        valid = false;
      }
      // if (
      //   (!WorkInformation.data.group || !WorkInformation.data.group.length) &&
      //   userRole==="employee"
      // ) {
      //   errors.group = true;
      //   valid = false;
      // }

      if (
        (!WorkInformation.data.city || !WorkInformation.data.city.length) &&
        userRole === "employee"
      ) {
        errors.city = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.address ||
          WorkInformation.data.address === "") &&
        userRole === "employee"
      ) {
        errors.address = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.county || !WorkInformation.data.county.length) &&
        userRole === "employee"
      ) {
        errors.county = true;
        valid = false;
      }
      if (!WorkInformation.data.country_list_id && userRole === "employee") {
        errors.country_list_id = true;
        valid = false;
      }
      // if (
      //   (!WorkInformation.data.zipcode ||
      //     !WorkInformation.data.zipcode.length) &&
      //   userRole==="employee"
      // ) {
      //   errors.zipcode = true;
      //   valid = false;
      // }
      if (
        (!WorkInformation.data.postcode ||
          !WorkInformation.data.postcode.length) &&
        userRole === "employee"
      ) {
        errors.postcode = true;
        valid = false;
      }
      // if (
      //   (!WorkInformation.data.mobile || !WorkInformation.data.mobile.length) &&
      //   userRole==="employee"
      // ) {
      //   errors.mobile = true;
      //   valid = false;
      // }
      if (
        (!WorkInformation?.data?.phone ||
          WorkInformation?.data?.phone.length < 3) &&
        userRole === "employee"
      ) {
        errors.phone = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.employee_status_id ||
          typeof WorkInformation.data.employee_status_id !== "number") &&
        userRole === "admin"
      ) {
        errors.employee_status_id = true;
        valid = false;
      }
      if (!WorkInformation.data?.selected_job_roles?.length) {
        errors.selected_job_roles = true;
        valid = false;
      }

      if (
        WorkInformation.data?.selected_job_roles?.length !==
        WorkInformation.data?.job_role_lists?.length
      ) {
        errors.access_level = true;
        valid = false;
      }
      if (
        (!WorkInformation.data.level || WorkInformation.data.level === "0") &&
        userRole === "employee"
      ) {
        errors.level = true;
        valid = false;
      }

      if (WorkInformation.data.magic20_fields && userRole === "employee") {
        const magicFields = WorkInformation.data.magic20_fields;
        if (Object.keys(magicFields).length > 0) {
          for (let i in magicFields) {
            if (Array.isArray(magicFields[i]) && !(magicFields[i].length > 0)) {
              errors.magic20_fields[i] = true;
              valid = false;
            }
          }
        }
      }
      if (!WorkInformation.data.magic20_fields && userRole === "employee") {
        errors.magic20_fields = true;
        valid = false;
      }
      //  if(errors.country_list_id){
      //   dispatch(showSnackbar("error","Please Select Country",500));
      //  }
      if (!valid) {
        const isTrulyValid = Object.values(errors)
          .map((el) => {
            if (typeof el === "boolean") {
              return el;
            } else if (typeof el === "object" && el) {
              return Object.values(el);
            } else {
              return false;
            }
          })
          .flatMap((el) => el)
          .every((el) => el === false);
        if (isTrulyValid) {
          valid = true;
        }
      }

      if (!valid) {
        dispatch(SetWorkInformationError(errors));
        return;
      }
      const test = { ...WorkInformation.data };
      const mtest2Key =
        test.past_organisation &&
        test["past_organisation"].map((item) => item.id || item);

      test["past_organisation"] = mtest2Key;
      if (valid) {
        handleSubmit(
          test,
          "employee_work_information",
          UpdateWorkInformation,
          WorkInformation.section_id,
          onlySave,
          proceedFurther
          // authHeaders
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 2) {
      let valid = true;
      let errors = {};
      if (!valid) {
        dispatch(SetTrainingAndDevelopmentError(errors));
        return;
      }
      const test = { ...TrainingAndDevelopment.data };
      const mtest2Key =
        test.employee_candidate_statuses &&
        test["employee_candidate_statuses"].map((item) => item.value || item);
      const mtest2Key1 =
        test.future_assignment_options &&
        test["future_assignment_options"].map((item) => item.value || item);

      test["employee_candidate_statuses"] = mtest2Key;
      test["future_assignment_options"] = mtest2Key1;

      handleSubmit(
        test,
        "employee_training_and_development",
        UpdateTrainingAndDevelopment,
        TrainingAndDevelopment.section_id,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 3) {
      let valid = true;
      let errors = {
        role: false,
      };
      // if (!CoachingCapacity.data.role || !CoachingCapacity.data.role.length) {
      //   errors.role = true;
      //   valid = false;
      // }
      if (!valid) {
        dispatch(SetCoachingCapacityError(errors));
        return;
      }
      if (!CoachingCapacity.data.role) {
        CoachingCapacityFormData.append("role", "Coaching");
      }
      handleSubmit(
        CoachingCapacity.data,
        "employee_mentoring_capacity",
        UpdateCoachingCapacity,
        CoachingCapacity.section_id,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 4) {
      handleSubmit(
        MentoringCapacity.data,
        // MentoringCapacityFormData,
        "employee_mentoring_capacity",
        UpdateMentoringCapacity,
        MentoringCapacity.section_id,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 7) {
      let valid = true;

      let errors = {};

      userRole === "employee" &&
        Object.keys(CoachingProfileCapacity.data).forEach((el) => {
          const element = CoachingProfileCapacity.data[el];
          if (!(el === "cli_expertises")) {
            if (element) {
              if (typeof element === "object") {
                if (!(element.length > 0)) {
                  errors[el] = true;
                  valid = false;
                }
              } else if (typeof element === "string") {
                if (
                  element === "" ||
                  element === "null" ||
                  element?.length === 0
                ) {
                  errors[el] = true;
                  valid = false;
                }
              }
            } else {
              errors[el] = true;
              valid = false;
            }
          }
        });

      if (!valid) {
        dispatch(SetCoachingProfileError(errors));
        return;
      }

      if (!CoachingProfileCapacity.data.role) {
        CoachingProfileCapacityFormData.append("role", "Coaching");
      }
      if (valid) {
        handleSubmit(
          // CoachingProfileCapacity.data,
          CoachingProfileCapacityFormData,
          "employee_coaching_profile",
          UpdateCoachingProfile,
          CoachingProfileCapacity.section_id,
          onlySave,
          proceedFurther
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 8) {
      let valid = true;
      let errors = {
        // role: false,
        overview: false,
        approach: false,
        background: false,
        expertise_area_id: false,
        cli_expertise_id: false,
        representatitive_clients: false,
        education_and_qualifications: false,
        client_testimonials: false,
        diagnostic_tool_id: false,
        language_list_id: false,
        client_type_id: false,
        picture: false,
      };
      if (
        (!MentorProfile.data.overview || !MentorProfile.data.overview.length) &&
        !feildIsMandatory
      ) {
        errors.overview = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.approach || !MentorProfile.data.approach.length) &&
        !feildIsMandatory
      ) {
        errors.approach = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.background ||
          !MentorProfile.data.background.length) &&
        !feildIsMandatory
      ) {
        errors.background = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.expertise_areas ||
          !MentorProfile.data.expertise_areas.length) &&
        !feildIsMandatory
      ) {
        errors.expertise_areas = true;
        valid = false;
      }
      // if (
      //   (!MentorProfile.data.cli_expertises ||
      //     !MentorProfile.data.cli_expertises.length) &&
      //   !feildIsMandatory
      // ) {
      //   errors.cli_expertises = true;
      //   valid = false;
      // }
      if (
        (!MentorProfile.data.representatitive_clients ||
          !MentorProfile.data.representatitive_clients.length) &&
        !feildIsMandatory
      ) {
        errors.representatitive_clients = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.education_and_qualifications ||
          !MentorProfile.data.education_and_qualifications.length) &&
        !feildIsMandatory
      ) {
        errors.education_and_qualifications = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.client_testimonials ||
          !MentorProfile.data.client_testimonials.length) &&
        !feildIsMandatory
      ) {
        errors.client_testimonials = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.diagnostic_tools ||
          !MentorProfile.data.diagnostic_tools.length) &&
        !feildIsMandatory
      ) {
        errors.diagnostic_tools = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.language_lists ||
          !MentorProfile.data.language_lists.length) &&
        !feildIsMandatory
      ) {
        errors.language_lists = true;
        valid = false;
      }
      if (
        (!MentorProfile.data.client_types ||
          !MentorProfile.data.client_types.length) &&
        !feildIsMandatory
      ) {
        errors.client_types = true;
        valid = false;
      }
      // if (
      //   MentorProfile.data.picture === null &&
      //   MentorProfile.datapicture === " "
      // ) {
      //   errors.picture = true;
      //   valid = false;
      // }
      if (!valid) {
        dispatch(SetMentorProfileError(errors));
        return;
      }
      if (!MentorProfile.data.role) {
        MentorProfileFormData.append("role", "Mentoring");
      }
      if (valid) {
        handleSubmit(
          // MentorProfile.data,
          MentorProfileFormData,
          "employee_coaching_profile",
          UpdateMentorProfile,
          MentorProfile.section_id,
          onlySave,
          proceedFurther
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 9) {
      let valid = true;
      let errors = { facilitator_aoes: false, facilitation_clients: false };
      if (
        !Facilitation?.data?.facilitator_aoes?.length &&
        userRole === "employee"
      ) {
        errors.facilitator_aoes = true;
        valid = false;
      }

      if (
        !Facilitation?.data?.facilitation_clients?.length > 0 &&
        userRole === "employee"
      ) {
        errors.facilitation_clients = true;
        valid = false;
      }

      if (!valid) {
        dispatch(SetFacilitationError(errors));
        return;
      }
      if (valid) {
        handleSubmit(
          // Facilitation.data,
          FacilitationFormData,
          "employee_facilitations",
          UpdateFacilitation,
          Facilitation.section_id,
          onlySave,
          proceedFurther
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 10) {
      let valid = true;
      let errors = { type_of_assessments: false, assessment_clients: false };
      const formDataObj = {
        "type_of_assessments[]": [],
        assessment_clients: "",
      };
      AccessmentFormData.forEach((value, key) => {
        if (value) {
          if (formDataObj[key]) {
            if (key === "type_of_assessments[]") {
              formDataObj[key] = [...formDataObj[key], value];
            } else {
              formDataObj[key] = [formDataObj[key], value];
            }
          } else {
            if (key === "type_of_assessments[]") {
              formDataObj[key] = [value];
            } else {
              formDataObj[key] = value;
            }
          }
        }
      });

      if (
        !(formDataObj["type_of_assessments[]"]?.length > 0) &&
        userRole === "employee"
      ) {
        errors.type_of_assessments = true;
        valid = false;
      }
      if (formDataObj["assessment_clients"] === "" && userRole === "employee") {
        errors.assessment_clients = true;
        valid = false;
      }
      if (!valid) {
        dispatch(SetAccessmentError(errors));
        return;
      }
      if (valid) {
        handleSubmit(
          // Accessment.data,
          AccessmentFormData,
          "employee_assessments",
          UpdateAccessment,
          Accessment.section_id,
          onlySave,
          proceedFurther
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 11) {
      let valid = true;
      let errors = {
        consent_status: false,
        consent_expiry_date: false,
        consent_terms: false,
        lawful_bia_id: false,
        purposes: false,
        contact_status: false,
      };
      if (
        (!Gdpr.data.consent_status || !Gdpr.data.consent_status.length) &&
        feildIsMandatory
      ) {
        errors.consent_status = true;
        valid = false;
      }
      if (!Gdpr.data.consent_expiry_date && feildIsMandatory) {
        errors.consent_expiry_date = true;
        valid = false;
      }
      if (
        (!Gdpr.data.consent_terms || !Gdpr.data.consent_terms.length) &&
        feildIsMandatory
      ) {
        errors.consent_terms = true;
        valid = false;
      }
      if (
        (!Gdpr.data.lawful_bia_id ||
          typeof Gdpr.data.lawful_bia_id !== "number") &&
        feildIsMandatory
      ) {
        errors.lawful_bia_id = true;
        valid = false;
      }
      if (!(Gdpr?.data?.purposes?.length > 0) && feildIsMandatory) {
        errors.purposes = true;
        valid = false;
      }
      if (
        (!Gdpr.data.contact_status || !Gdpr.data.contact_status.length) &&
        feildIsMandatory
      ) {
        errors.contact_status = true;
        valid = false;
      }

      if (!valid) {
        dispatch(SetGdprError(errors));
        return;
      }
      if (valid) {
        handleSubmit(
          Gdpr.data,
          // GdprFormData,
          "employee_gdprs",
          UpdateGdpr,
          Gdpr.section_id,
          onlySave,
          proceedFurther
        );
        for (let i in errors) {
          errors[i] = false;
        }
      }
    } else if (activeStep === 5) {
      let valid = true;
      let errors = {};
      if (!valid) {
        dispatch(SetBackgroundError(errors));
        return;
      }
      handleSubmit(
        Background.data,
        // BackgroundFormData,
        "employee_backgrounds",
        UpdateBackground,
        Background.section_id,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 6) {
      let valid = true;
      let errors = {};
      if (!valid) {
        dispatch(SetCoachingBackgroundError(errors));
        return;
      }
      handleSubmit(
        // Background.data,
        CoachingBackgroundFormData,
        "employee_coaching_backgrounds",
        UpdateCoachingBackground,
        CoachingBackground.section_id,
        onlySave,
        proceedFurther
      );
    }
  };

  const handleBack = () => {
    if (
      (activeStep === 9 ||
        activeStep === 7 ||
        activeStep === 10 ||
        activeStep === 4 ||
        activeStep === 8) &&
      filterJobLength !== "Internal Coach"
      // (activeStep === 5 && filterJobLength1 !== "Mentor") ||
      // (userRoleInternal && userRoleInternal.includes("Internal") === false  )
    ) {
      setActiveStep((prevActiveStep) => prevActiveStep - 2);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  const resetErrors = () => {
    let coachingProfileError = {
      approach: false,
      background: false,
      cli_expertises: false,
      client_testimonials: false,
      client_types: false,
      diagnostic_tools: false,
      education_and_qualifications: false,
      expertise_areas: false,
      language_lists: false,
      overview: false,
      representatitive_clients: false,
    };
    let mentorError = {
      // role: false,
      overview: false,
      approach: false,
      background: false,
      expertise_area_id: false,
      cli_expertise_id: false,
      representatitive_clients: false,
      education_and_qualifications: false,
      client_testimonials: false,
      diagnostic_tool_id: false,
      language_list_id: false,
      client_type_id: false,
      picture: false,
    };
    let workInfoErrors = {
      group: false,
      job_title: false,
      employee_status_id: false,
      current_role_history_notes: false,
      date_follow_up_contact_made: false,
      organisation_moved_to: false,
      level: false,
      line_manager_name: false,
      line_manager_contact_details: false,
      hr_sponsor_title: false,
      hr_sponsor_contact_details: false,
      city: false,
      county: false,
      country_list_id: false,
      zipcode: false,
      postcode: false,
      mobile: false,
      phone: false,
      selected_job_roles: false,
      left_organisation_follow_up_action: false,
      access_level: false,
      address: false,
      magic20_fields: {},
    };
    let gdprerrors = {
      consent_status: false,
      consent_expiry_date: false,
      consent_terms: false,
      lawful_bia_id: false,
      purposes: false,
      contact_status: false,
    };
    let assesmentError = {
      type_of_assessments: false,
      assessment_clients: false,
    };
    let facilitatorError = {
      facilitator_aoes: false,
      facilitation_clients: false,
    };

    dispatch(SetWorkInformationError(workInfoErrors));
    dispatch(SetGdprError(gdprerrors));
    dispatch(SetAccessmentError(assesmentError));
    dispatch(SetFacilitationError(facilitatorError));
    dispatch(SetMentorProfileError(mentorError));
    dispatch(SetCoachingProfileError(coachingProfileError));
  };
  const handleTabChange = (index) => {
    if (someChangeDetected) {
      setOpen(true);
    } else {
      setActiveStep(index);
      resetErrors();
    }
    setIndexValue(index);
    setSomeChangeDetected(false);
    // setActiveStep(index);
    window.scroll({ top: 0 });
  };
  let loginRole = globaluserData?.role
  // Form disabling
 
  let organisation_id = globaluserData.organisation_id
  let employee_id = globaluserData.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    loginRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }

  return (
    <div className={classes.root}>
      {loading && <Loader />}
      {/* <Snackbar/> */}
      <Stepper
        className={
          employeeId ? classes.stepperContent : classes.stepperContentCreate
        }
        activeStep={activeStep}
        connector={false}
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step
              // onClick={() => (
              //   employeeid ||
              //    (jobRole === "Internal Coach" && label === "Coaching Profile") ||
              //    (jobRole === "Mentor" && label === "Mentor Profile") ||
              //     (jobRole === "Facilitation" && label === "Facilitation")||
              //     (jobRole === "Assessor" && label === "Assessment")
              // ) ? handleTabChange(index) : ''}
              onClick={() =>
                // !employeeid ||
                ((index === 6 || index === 3 || index === 7) &&
                  filterJobLength !== "Internal Coach") ||
                ((index === 4 || index === 8) &&
                  filterJobLength1 !== "Internal Mentor") ||
                (userRoleInternal &&
                  userRoleInternal.includes("Internal") === false &&
                  index === 2) ||
                (index === 9 && filterJobLength2 !== "Internal Facilitator") ||
                (index === 10 && filterJobLength3 !== "Internal Assessor")
                  ? setTabIndex(index)
                  : movable === true
                  ? (handleTabChange(index), setTabIndex(index))
                  : setTabIndex(index)
              }
              key={label}
              {...stepProps}
              // style={{
              //   backgroundColor: activeStep === index ? "rgb(7, 127,131)" : "",
              //   cursor: (
              //     // employeeid ||
              //      (jobRole === "Internal Coach" && label === "Coaching Profile")||
              //      (jobRole === "Mentor" && label === "Mentor Profile") ||
              //        (jobRole === "Facilitation" && label === "Facilitation")||
              //         (jobRole === "Assessor" && label === "Assessment")
              //   ) ? "pointer" : 'not-allowed',
              //   height: '30px'
              // }}

              style={{
                backgroundColor:
                  ((index === 6 || index === 3 || index === 7) &&
                    filterJobLength !== "Internal Coach") ||
                  ((index === 4 || index === 8) &&
                    filterJobLength1 !== "Internal Mentor") ||
                  (userRoleInternal &&
                    userRoleInternal.includes("Internal") === false &&
                    index === 2) ||
                  (index === 9 &&
                    filterJobLength2 !== "Internal Facilitator") ||
                  (index === 10 && filterJobLength3 !== "Internal Assessor")
                    ? "#bdbdbd"
                    : activeStep === index
                    ? "rgb(7, 127,131)"
                    : "",
                cursor:
                  // employeeid
                  ((index === 6 || index === 3 || index === 7) &&
                    filterJobLength !== "Internal Coach") ||
                  ((index === 4 || index === 8) &&
                    filterJobLength1 !== "Internal Mentor") ||
                  (userRoleInternal &&
                    userRoleInternal.includes("Internal") === false &&
                    index === 2) ||
                  (index === 9 &&
                    filterJobLength2 !== "Internal Facilitator") ||
                  (index === 10 && filterJobLength3 !== "Internal Assessor")
                    ? "not-allowed"
                    : "pointer",
                height: "50px",
                display: "flex",
                alignItems: "center",
                // overflowY: "scroll",
                width: "865px",
                // overflowX: "scroll",
                overflow: "hidden",
              }}
            >
              <StepButton {...labelProps}>
                <Typography variant="h3" className={classes.stepperLabel}>
                  {label}
                </Typography>
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            {loginRole === "admin"
              ? history.push(`/admin/organisation/${id}/employee/list`)
              : history.push("/OrganizationHome")}
          </div>
        ) : (
          <div>
            <Typography variant="h2" className={classes.instructions}>
              {getStepContent(activeStep)}
            </Typography>
            <div className={classes.stepperButtons}>
              {activeStep !== 0 ? (
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.button}
                >
                  Back
                </Button>
              ) : (
                <span style={{ width: "20px" }}></span>
              )}
              {!unEditable && (
                <div
                  style={{
                    display: "flex",
                    width: "20%",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Button
                    disableElevation
                    variant="contained"
                    color="secondary"
                    onClick={handleNext}
                    style={{ width: "25%", textTransform: "none" }}
                  >
                    Save
                  </Button>
                  <Button
                    disableElevation
                    variant="contained"
                    color="secondary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {/* {activeStep === steps.length - 1
                    ?(userRole!=="admin" && activeStep===10)?"Save and proceed" :"Finish"
                    : "Save and proceed"} */}
                    Save and proceed
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div>
        <Dialog open={open} onClose={handleClose} indexValue={indexValue}>
          <DialogContent>
            <Grid container spacing={2} style={{ textAlign: "center" }}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Do you want to save the changes ?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  className={classes.button}
                  style={{ marginRight: "12px" }}
                >
                  Update
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  className={classes.button}
                  style={{ marginLeft: "12px" }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
